import { render } from "./PictureView.vue?vue&type=template&id=0b17f5e8"
import script from "./PictureView.vue?vue&type=script&lang=js"
export * from "./PictureView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pnz002/Project/dfy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__